import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getContabilidadDocumentosPendientes } from '../../helpers/api_helper';

const contabilidadDocumentosPendientesHooks = (limit = null, CLIPRO = '', RAZSOC = '', TIPDOC = '', FECVTO = '') => {
    const [documentos, setDocumentos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);
    const empresa = useSelector((state) => state.Context.empresa);

    useEffect(() => {
        const fetchDocumentos = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await getContabilidadDocumentosPendientes({ tenantId, empresa, limit, CLIPRO, RAZSOC, TIPDOC });
                console.log('Response from API:', response);
                if (Array.isArray(response)) {
                    // Filter out documents where VALTOT is 0 or irrelevant
                    const filtered = response.filter(doc => doc.VALTOT && doc.VALTOT > 0);
                    setDocumentos(filtered);
                } else {
                    throw new Error('API returned invalid data format: expected an array in data');
                }
            } catch (err) {
                setError(`Failed to fetch documentos pendientes: ${err.message || 'Unknown error'}`);
                setDocumentos([]);
            } finally {
                setLoading(false);
            }
        };

        if (tenantId && empresa) {
            fetchDocumentos();
        }
    }, [tenantId, empresa, limit, CLIPRO, RAZSOC, TIPDOC, FECVTO]);

    return { documentos, loading, error };
};

export default contabilidadDocumentosPendientesHooks;